import React, { Component } from "react";
import Select from "react-select";

// Components
import ErrorWrap from "../../../utils/error-success/ErrorWrap";
import CircleLoader from "../CircleLoader";
import PhoneField from "../../../utils/PhoneField";
import DynamicInputs from "../../../utils/DynamicInputs";

class ProfileTablePersonal extends Component {
	render() {
		const {
			user,
			inProgress,
			personalFieldsErrors,
			reviewerOptionsLoading,
			reviewerOptionsError,
			reviewerOptions,
			translations
		} = this.props;

		return (
			<React.Fragment>
				<tr
					className={
						!!personalFieldsErrors && personalFieldsErrors.salutation ? `error` : null
					}
				>
					<th>{translations.sections.reviewer_form.salutation}:</th>
					<td>
						{reviewerOptionsError ? (
							<ErrorWrap>{reviewerOptionsError}</ErrorWrap>
						) : (
							<React.Fragment>
								{!!reviewerOptionsLoading && <CircleLoader />}

								{!!reviewerOptions && !!reviewerOptions.salutations && (
									<Select
										classNamePrefix="react-select"
										placeholder={translations.sections.form_elements.select_one}
										isClearable={false}
										isDisabled={inProgress}
										name={`salutation`}
										value={reviewerOptions.salutations.filter(
											({ id }) => id === user.salutation
										)}
										onChange={({ id }) => {
											this.props.updateSelectedValue(id, "salutation");
										}}
										options={reviewerOptions.salutations}
										getOptionLabel={({ id }) => id}
										getOptionValue={({ id }) => id}
									/>
								)}
							</React.Fragment>
						)}
					</td>
				</tr>
				<tr
					className={
						!!personalFieldsErrors && personalFieldsErrors.title ? `error` : null
					}
				>
					<th>{translations.sections.reviewer_form.title}:</th>
					<td>
						<input
							type="text"
							id="title"
							value={user.title}
							maxLength="255"
							disabled={inProgress}
							onKeyPress={e => this.props.handleKeyPress(e)}
							onChange={e => this.props.handleInputChange(e)}
							placeholder="CEO"
						/>
					</td>
				</tr>
				<tr
					className={
						!!personalFieldsErrors && personalFieldsErrors.fname ? `error` : null
					}
				>
					<th>{translations.sections.reviewer_form.first_name}:</th>
					<td>
						<input
							type="text"
							id="fname"
							value={user.fname}
							maxLength="255"
							disabled={inProgress}
							onKeyPress={e => this.props.handleKeyPress(e)}
							onChange={e => this.props.handleInputChange(e)}
							placeholder="John"
						/>
					</td>
				</tr>
				<tr
					className={
						!!personalFieldsErrors && personalFieldsErrors.lname ? `error` : null
					}
				>
					<th>{translations.sections.reviewer_form.last_name}:</th>
					<td>
						<input
							type="text"
							id="lname"
							value={user.lname}
							maxLength="255"
							disabled={inProgress}
							onKeyPress={e => this.props.handleKeyPress(e)}
							onChange={e => this.props.handleInputChange(e)}
							placeholder="Doe"
						/>
					</td>
				</tr>
				<tr
					className={
						!!personalFieldsErrors && personalFieldsErrors.email ? `error` : null
					}
				>
					<th>{translations.sections.reviewer_form.email}:</th>
					<td>
						<input
							type="email"
							id="email"
							value={user.email}
							maxLength="255"
							disabled={inProgress}
							onKeyPress={e => this.props.handleKeyPress(e)}
							onChange={e => this.props.handleInputChange(e)}
							placeholder="email@domain.com"
						/>
					</td>
				</tr>
				<tr
					className={
						!!personalFieldsErrors && personalFieldsErrors.alternate_emails
							? `error`
							: null
					}
				>
					<th>{translations.sections.reviewer_form.alternate_emails}:</th>
					<td>
						<DynamicInputs
							index="alternate_emails"
							addInputToCollection={this.props.addInputToCollection}
						>
							{user.alternate_emails.map((alt_email, i) => (
								<div key={i} className="dynamic-input">
									<input
										type="email"
										name="alternate_emails"
										value={alt_email}
										maxLength="255"
										disabled={this.props.inProgress}
										onKeyPress={e => this.props.handleKeyPress(e)}
										onChange={e => this.props.handleInputChangeArray(e, i)}
										placeholder="email@domain.com"
									/>
									{!!i && (
										<span
											className="icon-cross"
											onClick={() =>
												this.props.deleteInputFromCollection(
													"alternate_emails",
													i
												)
											}
										/>
									)}
								</div>
							))}
						</DynamicInputs>
					</td>
				</tr>
				<tr
					className={
						!!personalFieldsErrors &&
						(personalFieldsErrors.phone || personalFieldsErrors.phone_extension)
							? `error`
							: null
					}
				>
					<th>{translations.sections.reviewer_form.phone}:</th>
					<td className="phone-cell">
						<PhoneField
							phone_name={`phone`}
							phone={user.phone}
							ext_name={`phone_extension`}
							extension={user.phone_extension}
							inProcess={inProgress}
							handleKeyPress={this.props.handleKeyPress}
							handleInputChange={this.props.handleInputChange}
							translations={translations}
						/>

						<div className="phone-type-wrapper">
							{reviewerOptionsError ? (
								<ErrorWrap>{reviewerOptionsError}</ErrorWrap>
							) : (
								<React.Fragment>
									{!!reviewerOptionsLoading && <CircleLoader />}

									{!!reviewerOptions && !!reviewerOptions.phoneTypes && (
										<Select
											classNamePrefix="react-select"
											placeholder={
												translations.sections.form_elements.select_one
											}
											isClearable={false}
											isDisabled={inProgress}
											name={`phone_type`}
											value={reviewerOptions.phoneTypes.filter(
												({ id }) => id === user.phone_type
											)}
											onChange={({ id }) => {
												this.props.updateSelectedValue(id, "phone_type");
											}}
											options={reviewerOptions.phoneTypes}
											getOptionLabel={({ title }) => title}
											getOptionValue={({ id }) => id}
										/>
									)}
								</React.Fragment>
							)}
						</div>
					</td>
				</tr>
				<tr
					className={
						!!personalFieldsErrors &&
						(personalFieldsErrors.phone_alternate ||
							personalFieldsErrors.phone_alternate_extension)
							? `error`
							: null
					}
				>
					<th>{translations.sections.reviewer_form.alt_phone}:</th>
					<td className="phone-cell">
						<PhoneField
							phone_name={`phone_alternate`}
							phone={user.phone_alternate}
							ext_name={`phone_alternate_extension`}
							extension={user.phone_alternate_extension}
							inProcess={inProgress}
							handleKeyPress={this.props.handleKeyPress}
							handleInputChange={this.props.handleInputChange}
							translations={translations}
						/>

						<div className="phone-type-wrapper">
							{reviewerOptionsError ? (
								<ErrorWrap>{reviewerOptionsError}</ErrorWrap>
							) : (
								<React.Fragment>
									{!!reviewerOptionsLoading && <CircleLoader />}

									{!!reviewerOptions && !!reviewerOptions.phoneTypes && (
										<Select
											classNamePrefix="react-select"
											placeholder={
												translations.sections.form_elements.select_one
											}
											isClearable={false}
											isDisabled={inProgress}
											name={`phone_alternate_type`}
											value={reviewerOptions.phoneTypes.filter(
												({ id }) => id === user.phone_alternate_type
											)}
											onChange={({ id }) => {
												this.props.updateSelectedValue(
													id,
													"phone_alternate_type"
												);
											}}
											options={reviewerOptions.phoneTypes}
											getOptionLabel={({ title }) => title}
											getOptionValue={({ id }) => id}
										/>
									)}
								</React.Fragment>
							)}
						</div>
					</td>
				</tr>
				<tr
					className={
						!!personalFieldsErrors && personalFieldsErrors.organization ? `error` : null
					}
				>
					<th>{translations.sections.reviewer_form.organization}:</th>
					<td>
						<input
							type="text"
							id="organization"
							value={user.organization}
							maxLength="255"
							disabled={inProgress}
							onKeyPress={e => this.props.handleKeyPress(e)}
							onChange={e => this.props.handleInputChange(e)}
							placeholder={
								translations.sections.reviewer_form.organization_placeholder
							}
						/>
					</td>
				</tr>
				<tr
					className={
						!!personalFieldsErrors && personalFieldsErrors.language ? `error` : null
					}
				>
					<th>{translations.sections.reviewer_form.language}:</th>
					<td>
						<div
							className={`custom-label checkbox-label round-label${
								inProgress ? " disabled-label" : ""
							}`}
						>
							<input
								type="radio"
								id="language_en"
								value="en"
								disabled={inProgress}
								checked={user.language === "en"}
								onChange={e => this.props.handleRadioClick(e, "language")}
							/>
							<label htmlFor="language_en">
								{translations.sections.languages.english}
							</label>
						</div>

						<div
							className={`custom-label checkbox-label round-label${
								inProgress ? " disabled-label" : ""
							}`}
						>
							<input
								type="radio"
								id="language_fr"
								value="fr"
								disabled={inProgress}
								checked={user.language === "fr"}
								onChange={e => this.props.handleRadioClick(e, "language")}
							/>
							<label htmlFor="language_fr">
								{translations.sections.languages.french}
							</label>
						</div>

						<div
							className={`custom-label checkbox-label round-label${
								inProgress ? " disabled-label" : ""
							}`}
						>
							<input
								type="radio"
								id="language_other"
								value="other"
								disabled={inProgress}
								checked={user.language === "other"}
								onChange={e => this.props.handleRadioClick(e, "language")}
							/>
							<label htmlFor="language_other">
								{translations.sections.languages.other}
							</label>
						</div>
					</td>
				</tr>
			</React.Fragment>
		);
	}
}

export default ProfileTablePersonal;



// WEBPACK FOOTER //
// ./src/components/reviewer/profile/profile-table/ProfileTablePersonal.js